import React, { useState } from "react";
import Modal from "react-modal";
import { inject, observer } from "mobx-react";
import "../../../assets/css/components/Modal/Modal.css";
import "../../../assets/css/components/Authentication/SetPassword/SetPassword.css";
import constant from "../../../common/constant"

const SetPassword = inject("sharedStore")(observer((props) => {
    const { sharedStore, modalVisibility, closeModalHandler, modalClass, forgotEmail, otp, switchModalVisibility } = props;
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordStatus, setPasswordStatus] = useState(constant.passwordStatus);
    const [showPasswordMessage, setPasswordMessage] = useState(false)
    const [invalidConfirmPassword, setInvalidConfirmPassword] = useState(false);

    const onFormSubmit = (e) => {
        e.preventDefault();
        sharedStore.showLoader();
        let data = {
            password: password,
            email: forgotEmail,
            activation_key: otp,
        };
        fetch("api/user/forgotpassword/", {
            method: "put",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        }).then((json) => {
            sharedStore.hideLoader();
            if (json.error === false) {
                let data = {
                    successMessage:
                        "Password has been updated, Now you can login with new password",
                };
                switchModalVisibility(null, 3, data);
            } else if (json.status_code === 402) {
            } else {
                console.log('error')
            }
        });
    };


    const onInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value
        if (name === "confirmPassword") {
            setConfirmPassword(value)
            const isEqual = value === password ? false : true
            setInvalidConfirmPassword(isEqual)
            if (!password) {
                let x = [...passwordStatus]
                // eslint-disable-next-line array-callback-return
                x && x.map((val) => {
                    if (!val.error) {
                        val.error = true
                    }
                })
                setPasswordStatus(x)
            }

        }
        else {
            setPassword(value)
            setInvalidConfirmPassword(confirmPassword.length > 0 && value !== confirmPassword ? true : false)
            console.log('password222222')
            validatePassword(value);
        }
    }

    const validatePassword = (password) => {
        console.log('password',password)
        let x = passwordStatus;
        // eslint-disable-next-line array-callback-return
        x && x.map((val) => {
            if (val.regex && val.regex.test(password)) {
                console.log('val',val.type)
                val.error = false
            }
            else if(val.type === "length"){
                console.log('im in')
                val.error = password.length >= 8 && password.length  <=20 ? false : true
            }
            else {              
                val.error = true
            }
        })

        const result = x.filter((o) => !o.error)
        let flag = true
        if (result.length === passwordStatus.length) {
            flag = false
        }
        setPasswordMessage(flag)
        setPasswordStatus(x)

    }



    const invalidPasswordCheck = () => {
        // eslint-disable-next-line no-sequences
        const result = passwordStatus.reduce((a, o) => (o.error && a.push(o.Msg), a), [])
        return result && result.map((val, i) => {
            return (
                <p key={i}
                    className={"error-true"} >
                    <span className="fa fa-times error-true" />
                    {val}
                </p>
            )
        })
    }

    const validPasswordCheck = () => {
        // eslint-disable-next-line no-sequences
        const result = passwordStatus.reduce((a, o) => (!o.error && a.push(o.Msg), a), [])
        if (result.length === passwordStatus.length) {
            return null
        }
        else {
            return result && result.map((val, i) => {
                return (
                    <p key={i}
                        className={"error-false"} >
                        <span className="fa fa-check error-false" />
                        {val}
                    </p>
                )
            })
        }
    }

    const isFormValid = () => {
        if (password.length > 0 && confirmPassword.length > 0 && (password === confirmPassword)) {
            return true
        }
    }
    return (
        <Modal
            isOpen={modalVisibility}
            onRequestClose={closeModalHandler}
            className={modalClass}
            shouldCloseOnOverlayClick={false}
            contentLabel="Set Password Modal"
        >
            <div className="text-right">
                <span className="span-style" onClick={closeModalHandler}>
                    <i className="fa fa-close" aria-hidden="true" />
                </span>
            </div>
            <div className="inner forget_password">
                <form>
                    <p className="password-heading text-center fw">Forgot Password ?</p>
                    <label className="pull-left fs-small mar-l">New Password:</label>
                    <input
                        type="password"
                        name="password"
                        onChange={(e) => onInputChange(e)}
                        placeholder="Enter New Password"
                        value={password}
                        className={showPasswordMessage ? "prompt-text error-border" : "prompt-text"}
                    />
                    <div className="msg_passwordError text-left">
                        {validPasswordCheck()}
                        {invalidPasswordCheck()}
                    </div>

                    <label className="pull-left fs-small mar-l">
                        Confirm Password:
                    </label>
                    <input
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm Password"
                        onChange={(e) => onInputChange(e)}
                        value={confirmPassword}
                        className={invalidConfirmPassword ? "prompt-text error-border" : "prompt-text"}
                    />
                    <div className="msg_passwordError text-left">
                        {
                            invalidConfirmPassword ?
                                <p
                                    className={"error-true"} >
                                    <span className="fa fa-times error-true" />
                                Password and confirm password does not match.
                            </p> : null
                        }
                    </div>
                    <div className="row col-md-12">
                        <button
                            className={
                                !isFormValid()
                                    ? "col-md-6 btn-red btn-align not-allowed"
                                    : "col-md-6 btn-red btn-align"
                            }
                            type="submit"
                            onClick={(e) => onFormSubmit(e)}
                            disabled={!isFormValid()}
                        >
                            Submit
                    </button>
                    </div>
                </form>
            </div>
        </Modal>
    );

}))
export default SetPassword;



// WEBPACK FOOTER //
// ./src/components/Authentication/SetPassword/SetPassword.jsx